export const noMoreLonelyWords = (selector, numWords) => {
  var elems = document.querySelectorAll(selector);
  var i;
  for (i = 0; i < elems.length; ++i) {
    var textArray = elems[i].innerText.split(" ");
    var lastWords = textArray.splice(-numWords, numWords).join("&nbsp;");
    var textMinusLastWords = textArray.join(" ");
    elems[i].innerHTML = textMinusLastWords + " " + lastWords;
  }  
}

export const drawCanvas = () => {
  const c = document.getElementById("canvas");
    const lineH = c.getContext("2d");
    const lineV = c.getContext("2d");
    c.width = window.innerWidth;
    c.height = window.innerHeight;

    const lineColor = "grey"

    let element = document.querySelector('div')

    const positionCanvas = () => {
      lineV.clearRect(0, 0, c.width, c.height);
      let position1 = document.querySelector('.coluna2').offsetLeft
      let position2 = document.querySelector('.parte-inferior').offsetTop + 124

      //bug correction - It avoids the canvas line displace when the vertical scroll appears     
      if (document.body.scrollHeight > (window.innerHeight - 128)) {
        position1 += 10;
      }

      lineH.fillStyle = lineColor;
      lineH.fillRect(0, position2, window.innerWidth, 2);

      lineH.fill();

      lineV.fillStyle = lineColor;
      lineV.fillRect(position1, 0, 2, window.innerHeight);

      lineV.fill();
    }

    positionCanvas()
  }








// WEBPACK FOOTER //
// ./src/utilities/utilities.js